import axios from 'axios';

export const bulkImportApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND}api/bulk-import`,
    headers: {
        'Content-Type': 'application/json'
    }
})